import { toast } from "react-toastify";
import { store } from "../store";
import { UpdatePracticePopupAction } from "../Redux/UserAuthSlice/UserAuthSlice";
export const ErrorHandlingMessage = (error) => {
  console.log("ErrorHandlingMessage", error);
  if (error?.response) {
    if (error.response.data.errors) {
      for (const errr in error.response.data.errors) {
        toast.error(`${errr}: ${error.response.data.errors[errr]} `);
      }
    } else if (error.response.data) {
      toast[error.response.data.errorType || "error"](
        error.response.data.responseMessage
      );

      if (
        error.response.data.responseMessage ===
        "Practice has been changed. Please Re-login."
      ) {
        store.dispatch(UpdatePracticePopupAction(true));
      }
    }
  } else {
    for (const key in error) {
      if (error[key]) {
        toast(({ closeToast }) => <div> {error[key]}</div>, { type: "error" });
      }
    }
  }
};
